module.exports = __webpack_public_path__ + "img/gold.8288d28e.png";